import React from 'react';
import { View, Text, TouchableOpacity } from 'react-native';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const location = useLocation();

  return (
    <View style={headerStyles.container}>
      <View style={headerStyles.content}>
        {/* Logo Section - positioned above sidebar */}
        <View style={headerStyles.logoSection}>
          <img 
            src="/zecher-logo.png" 
            alt="Zecher"
            style={headerStyles.logoImage}
            onError={(e) => {
              // Fallback to text logo if image fails to load
              e.target.style.display = 'none';
              e.target.nextSibling.style.display = 'flex';
            }}
          />
          <View style={[headerStyles.logoFallback, { display: 'none' }]}>
            <View style={headerStyles.logoIcon}>
              <Text style={headerStyles.logoIconText}>Z</Text>
            </View>
            <Text style={headerStyles.logoTitle}>echer</Text>
          </View>
        </View>

        {/* Right Section - Help & Auth */}
        <View style={headerStyles.rightSection}>
          {/* Help Link */}
          <Link to="/help" style={headerStyles.helpLink}>
            <View style={[
              headerStyles.helpButton,
              location.pathname === '/help' && headerStyles.helpButtonActive
            ]}>
              <Text style={[
                headerStyles.helpText,
                location.pathname === '/help' && headerStyles.helpTextActive
              ]}>
                Help
              </Text>
            </View>
          </Link>

          {/* Auth Section */}
          <View style={headerStyles.authSection}>
            <TouchableOpacity style={headerStyles.loginButton}>
              <Text style={headerStyles.loginText}>Log in</Text>
            </TouchableOpacity>
            <TouchableOpacity style={headerStyles.signUpButton}>
              <Text style={headerStyles.signUpText}>Sign up</Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    </View>
  );
};

const headerStyles = {
  container: {
    backgroundColor: '#FFFFFF',
    borderBottomWidth: 1,
    borderBottomColor: '#E5E7EB',
    paddingVertical: 0,
  },
  content: {
    width: '100%',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingLeft: 0,
    paddingRight: 24,
    paddingVertical: 16,
  },
  
  // Logo Section
  logoSection: {
    width: 288,
    paddingHorizontal: 24,
    paddingVertical: 16,
    alignItems: 'center',
    justifyContent: 'center',
  },
  logoImage: {
    height: 32,
    width: 'auto',
    maxWidth: 200,
    objectFit: 'contain',
  },
  logoFallback: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  logoIcon: {
    width: 32,
    height: 32,
    backgroundColor: '#2563EB',
    borderRadius: 6,
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 8,
  },
  logoIconText: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#FFFFFF',
  },
  logoTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#111827',
  },

  // Right Section
  rightSection: {
    flex: 0,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  helpLink: {
    marginRight: 24,
  },
  helpButton: {
    paddingVertical: 8,
    paddingHorizontal: 16,
    borderRadius: 8,
  },
  helpButtonActive: {
    backgroundColor: '#EFF6FF',
  },
  helpText: {
    fontSize: 16,
    fontWeight: '500',
    color: '#374151',
  },
  helpTextActive: {
    color: '#2563EB',
    fontWeight: '600',
  },

  // Auth Section
  authSection: {
    flex: 0,
    flexDirection: 'row',
    alignItems: 'center',
    minWidth: 140,
    justifyContent: 'flex-end',
  },
  loginButton: {
    paddingVertical: 8,
    paddingHorizontal: 12,
    borderRadius: 6,
    marginRight: 16,
  },
  loginText: {
    fontSize: 16,
    fontWeight: '500',
    color: '#374151',
  },
  signUpButton: {
    backgroundColor: '#2563EB',
    paddingVertical: 10,
    paddingHorizontal: 20,
    borderRadius: 8,
  },
  signUpText: {
    fontSize: 16,
    fontWeight: '600',
    color: '#FFFFFF',
  },
};

export default Header; 